// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__THe_O","title":"styles_title__u9Nug","container":"styles_container__pkpRG"};